module.exports = __webpack_public_path__ + "img/Carousel-Beneficios-icono-07.7613db15.svg";